import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExternalLoadService {
  private readonly document = inject(DOCUMENT);

  private _loadedLibraries: { [id: string]: ReplaySubject<boolean> } = {};

  public loadScript(id: string, scriptText?: string): Observable<boolean> {
    const scriptId = id;
    if (this._loadedLibraries[scriptId]) {
      return this._loadedLibraries[scriptId].asObservable();
    }

    if (!scriptText) {
      return of(false);
    }

    this._loadedLibraries[id] = new ReplaySubject();

    const script = this.document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.text = scriptText;
    script.onload = () => {
      this._loadedLibraries[scriptId].next(true);
      this._loadedLibraries[scriptId].complete();
    };

    script.onerror = () => {
      this._loadedLibraries[scriptId].next(false);
      this._loadedLibraries[scriptId].complete();
    };

    this.document.body.appendChild(script);

    this._loadedLibraries[scriptId].next(true);

    return this._loadedLibraries[scriptId].asObservable();
  }

  public loadScriptByUrl(url: string, insertInto: 'body' | 'head' = 'head'): Observable<boolean> {
   
    if (this._loadedLibraries[url]) {
      return this._loadedLibraries[url].asObservable();
    }

    this._loadedLibraries[url] = new ReplaySubject();

    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = url;
    script.id = url;
    script.onload = () => {
      this._loadedLibraries[url].next(true);
      this._loadedLibraries[url].complete();
    };
    script.onerror = () => {
      this._loadedLibraries[url].next(false);
      this._loadedLibraries[url].complete();
    };

    // this.document.body.appendChild(script);

    const insertRef = this.document[insertInto].firstChild;
    insertRef.parentNode.insertBefore(script, insertRef);
    console.log('[ExternalLoadService]', '[LoadScript]', { url, _loadedLibraries: this._loadedLibraries });

    return this._loadedLibraries[url].asObservable();
  }

  public loadStyle(url: string): Observable<boolean> {
    if (this._loadedLibraries[url]) {
      return this._loadedLibraries[url].asObservable();
    }

    this._loadedLibraries[url] = new ReplaySubject();

    const style = this.document.createElement('link');
    style.type = 'text/css';
    style.href = url;
    style.rel = 'stylesheet';
    style.onload = () => {
      this._loadedLibraries[url].next(true);
      this._loadedLibraries[url].complete();
    };
    style.onerror = () => {
      this._loadedLibraries[url].next(false);
      this._loadedLibraries[url].complete();
    };

    const head = this.document.getElementsByTagName('head')[0];
    head.appendChild(style);

    return this._loadedLibraries[url].asObservable();
  }
}
